import { Component } from '@angular/core';
import { Product, ProductScope, TranslatePipe } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-technical-installation',
    templateUrl: './kn-br-technical-installation.component.html',
    styleUrls: ['./kn-br-technical-installation.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class KnBrTechnicalInstallationComponent {
  sections = [
  { key: 'TECHNICAL', label: 'Technical' },
  { key: 'INSTALLATION', label: 'Installation' },
];
openSections: { [key: string]: boolean } = {};
toggleSection(key: string) {
  this.openSections[key] = !this.openSections[key];
}
   product$: Observable<Product | null> = this.service
        .getProduct([ProductScope.DETAILS])
      constructor(
        protected service: CurrentProductService,
        protected knBrCommonService: KnBrCommonService,
       
      ){}
  isTechnicalOpen: boolean = false;

  toggleTechnicalSection(): void {
    this.isTechnicalOpen = !this.isTechnicalOpen;
  }

   download(data:any ) {
    if (data) {
      this.knBrCommonService.downloadFile(data.mediaUrl,data.title)
    }
  }
}

